module.exports = __webpack_public_path__ + "static/GilroyAlt-SemiBold-0cf9ae764f51c0d32cf7b40430a71f1f.eot";